// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_4a-0";
export var orangeButton = "_4a-1";